import { injectable } from 'tsyringe';
import { OWSettingsGames } from '../../odk-ts/ow-settings-games';

// -----------------------------------------------------------------------------
@injectable()
export class OWSettingsGamesWrapper {
  public async getOverlayEnabled(gameId: number) {
    return OWSettingsGames.getOverlayEnabled(gameId);
  }
}
